import React from "react";
import OrdersTab from "../OrdersTab/OrdersTab";
import RowActions from "./components/RowActions/RowActions";
import { TABS } from "../../config/tabs";

export default function GeneralPage(props) {
  return (
    <OrdersTab
      {...props}
      gaTab={TABS.GERAL}
      renderActions={(pedido, ctx) => (
        <RowActions
          pedido={pedido}
          setState={ctx.setState}
          onAnalyze={ctx.onAnalyze}
          canInlineCancel={ctx.canInlineCancel}
        />
      )}
    />
  );
}
